<template>
	<div v-if="activeFilters.length > 0" class="filter-chips d-flex align-items-center gap-2 flex-wrap">
		<div v-for="filter in activeFilters" :key="filter.name" class="filter-chip">
			<font-awesome-icon v-if="filter.icon" :icon="['fa', filter.icon.replace('fad fa-', '')]" class="me-1" />
			<span class="d-flex align-items-center filter-chip-label">{{ filter.label }}</span>
			<span class="d-flex align-items-center filter-chip-operator">is</span>
			<span
				class="d-flex align-items-center filter-chip-value"
				@click.stop="editFilter(filter.name, $event)"
				role="button"
				title="Click to edit"
			>
				{{ getDisplayValue(filter) }}
			</span>
			<button class="filter-chip-remove" @click="removeFilter(filter.name)" title="Remove filter">
				<font-awesome-icon :icon="['fa', 'times']" />
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FilterChips',
	props: {
		filters: {
			type: Object,
			required: true,
		},
		filterItems: {
			type: Array,
			required: true,
		},
		filterDisplayValues: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		activeFilters() {
			return this.filterItems
				.filter((item) => {
					const value = this.filters[item.name]
					return value !== null && value !== undefined && value !== ''
				})
				.map((item) => ({
					...item,
					value: this.filters[item.name],
				}))
		},
	},
	methods: {
		getDisplayValue(filter) {
			const value = filter.value

			// For select type filters, show the label from options
			if (filter.component === 'SelectItem' && filter.options) {
				const option = filter.options.find((opt) => (opt.id || opt.value) == value)
				if (option) {
					return option.name || option.label || value
				}
			}

			// For month type, format it nicely
			if (filter.component === 'MonthItem' && value) {
				const [year, month] = value.split('-')
				const date = new Date(year, month - 1)
				return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
			}

			// For date range
			if (filter.component === 'DateRangeItem' && value) {
				if (typeof value === 'string' && value.includes(',')) {
					const [start, end] = value.split(',')
					return `${start || '...'} to ${end || '...'}`
				}
			}

			// For people search, get the name from filterDisplayValues
			if (filter.component === 'PeopleSearchItem') {
				const displayValue = this.filterDisplayValues[filter.name]
				if (displayValue && displayValue.name) {
					return displayValue.name
				}
			}

			return value
		},
		removeFilter(filterName) {
			this.$emit('remove', filterName)
		},
		editFilter(filterName, event) {
			this.$emit('edit', filterName, event)
		},
	},
}
</script>

<style lang="scss" scoped>
.filter-chips {
	display: flex;
	align-items: center;
	gap: 0.5rem;
}

.filter-chip {
	display: inline-flex;
	align-items: center;
	height: 36px;
	padding: 0 12px;
	background-color: #fff;
	border: 1px solid #d0d2d2;
	border-radius: 99px;
	box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.08);
	font-size: 0.875rem;
	line-height: 1.5;
	white-space: nowrap;

	span:not(:first-child):not(:last-child) {
		height: 36px;
		line-height: 4px;
	}
}

.filter-chip svg,
.filter-chip i {
	font-size: 0.75rem;
	color: #6c757d;
	width: 0.75rem;
	height: 0.75rem;
}

.filter-chip-label {
	font-weight: 600;
	color: #191a1a;
	border-right: 1px solid #dee2e6;
	padding-right: 12px;
}

.filter-chip-operator {
	color: #6c757d;
	font-size: 0.8125rem;
	padding-right: 8px;
	padding-left: 8px;
	border-right: 1px solid #dee2e6;
}

.filter-chip-value {
	color: #191a1a;
	font-weight: 500;
	padding-right: 8px;
	padding-left: 8px;
	border-right: 1px solid #dee2e6;
	cursor: pointer;
	transition: background-color 0.15s ease;
}

.filter-chip-value:hover {
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 4px;
}

.filter-chip-remove {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	margin-left: 0.25rem;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: 3px;
	cursor: pointer;
	transition: background-color 0.15s ease;
}

.filter-chip-remove:hover {
	background-color: #dee2e6;
}

.filter-chip-remove svg,
.filter-chip-remove i {
	font-size: 0.65rem;
	color: #191a1a;
	width: 0.65rem;
	height: 0.65rem;
}
</style>
